import React from 'react';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../../components/InputFilterItem';
import SingleSelect from '../../../../components/SingleSelect';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface FilterOptions {
  ruleName?: string;
  ruleType?: string;
  status?: string;
  state?: string;
  city?: string;
}

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  ruleName: undefined,
  ruleType: undefined,
  status: undefined,
  state: undefined,
  city: undefined,
};

interface FilterAreaProps {
  filters: FilterOptions;
  setFilters: (filters: FilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const handleChange = (key: keyof FilterOptions, value: string | undefined) => {
    const processed = typeof value === 'string' && value.trim() === '' ? undefined : value;
    setFilters({ ...filters, [key]: processed });
  };

  const columnLabels = [
    t('mapTool.addressWhitelistRule.filters.ruleName'),
    t('mapTool.addressWhitelistRule.filters.ruleType'),
    t('mapTool.addressWhitelistRule.filters.status'),
    t('mapTool.addressWhitelistRule.filters.state'),
    t('mapTool.addressWhitelistRule.filters.city'),
  ];
  const labelClassName = getSmartLabelClassName(columnLabels);

  const ruleTypeOptions = [
    { label: t('mapTool.addressWhitelistRule.ruleType.basic'), value: '1' },
    { label: t('mapTool.addressWhitelistRule.ruleType.regex'), value: '2' },
  ];

  const statusOptions = [
    { label: t('mapTool.addressWhitelistRule.status.enabled'), value: '1' },
    { label: t('mapTool.addressWhitelistRule.status.disabled'), value: '0' },
  ];

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressWhitelistRule.filters.ruleName')}
            value={filters.ruleName ?? ''}
            onChange={(e) => handleChange('ruleName', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressWhitelistRule.placeholders.ruleNameFuzzy') as string}
          />
        </div>
        <div className="min-w-0">
          <SingleSelect
            label={t('mapTool.addressWhitelistRule.filters.ruleType')}
            options={ruleTypeOptions}
            value={filters.ruleType}
            onChange={(v) => handleChange('ruleType', v)}
            spanClassName={labelClassName}
            allowClear
          />
        </div>
        <div className="min-w-0">
          <SingleSelect
            label={t('mapTool.addressWhitelistRule.filters.status')}
            options={statusOptions}
            value={filters.status}
            onChange={(v) => handleChange('status', v)}
            spanClassName={labelClassName}
            allowClear
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressWhitelistRule.filters.state')}
            value={filters.state ?? ''}
            onChange={(e) => handleChange('state', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressWhitelistRule.filters.city')}
            value={filters.city ?? ''}
            onChange={(e) => handleChange('city', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterArea;
